const fontList = {
    "AbeeZee": "AbeeZee",
    "Archia": "Archia",
    "Alfa Slab One":"Alfa Slab One",
    "arcadeclassic":"arcade Classic",
    "AudioWide":"AudioWide",
    "Bangers":"Bangers",
    "Black Ops One":"Black Ops One",
    "bubblebath":"bubblebath",
    "Cabin Sketch":"Cabin Sketch",
    "Caveat":"Caveat",
    "Cascadia Code": "Cascadia Code",
    "Comfortaa": "Comfortaa",
    "Courier Prime": "Courier Prime",
    "digit":"digit",
    "Disposable Droid":"Disposable Droid",
    "DM Mono":"DM Mono",
    "Dotty":"Dotty",
    "Fantasque Sans Mono": "Fantasque Sans Mono",
    "Gochi Hand":"Gochi Hand",
    "Hermit": "Hermit",
    "Jost": "Jost",
    "IBM Plex Mono": "IBM Plex Mono",
    "joystix":"joystix",
    "Lekton": "Lekton",
    "luckiest guy":"luckiest guy",
    "monoton":"monoton",
    "Minecraft Reg": "Minecraft Reg",
    "Minecraft Alt": "Minecraft Alt",
    "Oxanium":"Oxanium",
    "Pacifio":"Pacifio",
    "pix-pixel":"pix-pixel",
    "pixel":"pixel",
    "Press Start":"Press Start",
    "Quarmic Sans": "Quarmic Sans",
    "Righteous": "Righteous",
    "Rhodium Libre": "Rhodium Libre",
    "Roboto Slab": "Roboto Slab",
    "Slabo 13px": "Slabo 13px", 
    "Sayso chich":"Sayso chich",
    "Sfpixelate":"Sfpixelate", 
    "Source Code pro": "Source Code pro",
    "Space Mono": "Space Mono",
    "Subway Ticker":"Subway Ticker",
}
const DATE_FORMATS = {
    SINCE_EPOCH: 'Since Epoch',
    FOR_TODAY: "For Today"
}

const INP_TYPES = {
    SIMPLE_INPUT: 0b00,
    CHECKBOX: 0b01,
    SELECTPANEL: 0b10,
    COLOR_INPUT: 0b11
}

const BORDER_STYLES = [
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
    'initial',
    ,'inherit'
]

const FONT_WEIGHTS = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900', 'bold', 'bolder']

export {
    fontList,
    DATE_FORMATS,
    INP_TYPES,
    BORDER_STYLES,
    FONT_WEIGHTS
}